import FocusDirective from '@/directives/Focus'
import TooltipDirective from '@/directives/Tooltip'

/**
 * @param {Vue | VueConstructor} vue
 */
export default function registerDirectives(vue) {
  vue.directive('focus', FocusDirective)
  vue.directive('tooltip', TooltipDirective)
}
